import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

const EmptyPlaceholder = ({ text }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <InfoOutlinedIcon className="text-gray-400 mb-2" style={{ fontSize: 38 }} />
      <p className="text-lg font-medium text-center text-gray-500">{text}</p>
    </div>
  );
};

export default EmptyPlaceholder;
